import React from 'react';
import { useTranslation } from 'react-i18next';
import Maps from '../../components/master/Maps';

export default function About() {
    const { t, i18n } = useTranslation();
    return (
        <div className='content about'>
            <h4 className='text-center text-medium mt20'>{t('About us')}</h4>
            <p className='mt10 text-justify'>
               {t('About us text')}
            </p>
            <h4 className='text-center text-medium mt20'>{t('Contact')}</h4>
            <div className='contact'>
                <div className='contact-child mt10'>
                    <span className='ltr'>021 - 91 06 51 51</span>
                    <i className='fas fa-phone' />
                </div>
                <div className='contact-child mt10'>
                    <span className='ltr'>https://www.hamrahac.com</span>
                    <i className='fas fa-globe' />
                </div>
                <div className='contact-child mt10'>
                    <span className='ltr'>https://www.instagram.com/hbkf.ir</span>
                    <i className='fab fa-instagram' />
                </div>
            </div>
            <div className='mt20'>
                <Maps loc={[35.788707, 51.504637]} />
            </div>
        </div>
    )

}
